import React from 'react';
import { IProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { useHistory } from 'react-router-dom';
import { RouterSettings } from 'constants/models/routerSettings';

const GameQualifyModal: React.FC<IProps> = (props) => {
  const routerHistory = useHistory();
  const reduxDispatch = useDispatch();
  const gameQualifyModalState = useSelector((rootState: RootReducersState) => rootState.modal.gameQualifyModalState);

  /**
   * @description 關閉視窗
   */
  const handleClose = () => {
    reduxDispatch(setGameQualifyModalVisibleAction(false));
  };

  /**
   * @description 前往抽獎活動
   */
  const handleGoGameClick = () => {
    // 關閉視窗後轉跳
    reduxDispatch(setGameQualifyModalVisibleAction(false));
    routerHistory.push(RouterSettings.MemberCenter.Game);
  };

  return (
    <>
      {gameQualifyModalState && gameQualifyModalState.visible && (
        <Modal
          visible={gameQualifyModalState.visible}
          confirmButton={false}
          cancelButton={false}
          onCancel={handleClose}
          containerStyles={{ width: 'unset' }}
        >
          <div className="gameQualifyModal">
            <div className="body">
              <div className="content">
                <div className="icon">
                  <img src={require('assets/images/gift.png')} alt="gift" />
                </div>
                <p className="text">
                  恭喜！您已符合抽獎資格！
                  <br />
                  可享有&nbsp;<span className="emphsis">{gameQualifyModalState.checkResult?.QUALIFIED_DCNT ?? 0}</span>&nbsp;次抽獎機會，請至
                  {/* 旺旺電商處要求調整 (2025/03/10) */}
                  <span style={{ color: 'red' }}>{'《會員中心 > 抽獎活動》'}</span>
                  參加抽獎。
                </p>
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="element__button element__button--red"
                  onClick={handleGoGameClick}
                >
                  現在去抽
                </button>
                <button
                  type="button"
                  className="element__button element__button--black"
                  onClick={handleClose}
                >
                  我知道了
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default GameQualifyModal;
